import React from 'react';
import { createPortal, render } from 'react-dom';
import { trackListView } from '../../analytics';
import { favouritesButtonHandler } from '../../helpers/favouritesHandler';
import ContextProvider from './listerContext';
import { MessagePropertiesProvider } from '../../contexts/messageProperties';
import ListerApp from './listerApp';
import ListerHeader from './components/header/headerContainer';

const listerHeaderRootElement = document.getElementById('listerHeaderRoot');
const listerRootElement = document.getElementById('listerRoot');

trackListView();

// NOTE: the initial fetch of the favourites happens in the globalRoot.tsx and is stored in the
// window.bbGlobal.miniFavouritesData.initialFavouritesPromise
// globalRoot is rendered only after DOMContentLoaded, that is why we need to delay listerRoot too.
// Otherwise, listerRoot will render faster - before window.bbGlobal.miniFavouritesData.initialFavouritesPromise is set.
window.addEventListener('DOMContentLoaded', () => {
  const ListerRoot = (): React.ReactElement => (
    <MessagePropertiesProvider>
      <ContextProvider>
        <>
          {listerHeaderRootElement && createPortal(<ListerHeader />, listerHeaderRootElement)}
          <ListerApp />
        </>
      </ContextProvider>
    </MessagePropertiesProvider>
  );

  if (listerRootElement) {
    render(<ListerRoot />, listerRootElement);
  }

  favouritesButtonHandler();
});
